export default "__VITE_ASSET__BW7n0ciy__"